import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { color, radius, mq } = theme.custom;
    return {
        pager: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 2,
            border: `1px solid ${color.borderStrong}`,
            borderRadius: radius.md,
            padding: 2,
            backgroundColor: color.surface,
            marginRight: 8,
            [mq.sm]: { marginRight: 0, flex: '0 0 auto !important' },
        },
        pagerText: {
            fontSize: 13,
            color: color.text.secondary,
            padding: '0 8px',
            fontVariantNumeric: 'tabular-nums',
            whiteSpace: 'nowrap',
        },
        banner: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '12px 16px',
            marginBottom: 16,
            borderRadius: radius.md,
            border: `1px solid ${color.tone.danger.main}`,
            backgroundColor: color.tone.danger.soft,
            color: color.tone.danger.onSoft,
            fontSize: 14,
            fontWeight: 500,
            '& svg': { fontSize: 20, color: color.tone.danger.main },
        },
        mono: { fontFamily: theme.custom.font.mono, fontSize: 12 },
        skeletons: { display: 'grid', gap: 16 },
    };
});
